import UserStarSvg from '@assets/images/svg/user-star.svg';
import React from 'react';

export interface UserStarIconProps {
    size?: number;
    color?: string;
}

export function UserStarIcon({ size = 24, color = '#333333' }: UserStarIconProps) {
    return (
        <UserStarSvg width={size} height={size} color={color} />
    );
}

export default UserStarIcon;
